module.exports = __webpack_public_path__ + "joy-static/media/unwrap-joy.7852d778.png";